export type UserType = 'internal' | 'external';

interface GtmConfig {
  userType: UserType;
  gaProperties: Record<string, string>;
  gaSource: Record<string, string>;
}

function isUserType(userType: unknown): userType is UserType {
  return userType === 'internal' || userType === 'external';
}

export function setGtmConfigCache(userType: UserType, gaProperties: Record<string, string>, gaSource: Record<string, string>) {
  sessionStorage.setItem('dataLayer__userType', userType);
  sessionStorage.setItem('dataLayer__gaProperties', JSON.stringify(gaProperties));
  sessionStorage.setItem('dataLayer__gaSource', JSON.stringify(gaSource));
}

async function getGtmConfig(): Promise<GtmConfig> {
  let url = '/gtm.php';

  let userType = <UserType>(sessionStorage.getItem('dataLayer__userType') || '');
  let gaProperties: Record<string, string> = JSON.parse(sessionStorage.getItem('dataLayer__gaProperties') || '{}');
  let gaSource: Record<string, string> = JSON.parse(sessionStorage.getItem('dataLayer__gaSource') || '{}');
  if (!isUserType(userType) || !Object.keys(gaProperties).length) {
    const response = await fetch(url);
    const data: GtmConfig = await response.json();

    userType = data.userType;
    gaProperties = data.gaProperties;
    setGtmConfigCache(userType, gaProperties, gaSource);
  }
  return {
    userType,
    gaProperties,
    gaSource,
  };
}

export async function injectTagManager() {
  const gtm = await getGtmConfig();

  (<any>window).dataLayer = [
    {
      event: 'userInfo',
      userType: gtm.userType,
    },
  ];
  const firstScriptTag: any = document.getElementsByTagName('script')[0];
  const usercentricsScriptTag = document.createElement('script');
  usercentricsScriptTag.type = 'text/javascript';
  usercentricsScriptTag.innerHTML = '' +
    'function gtag() {\n' +
    '    dataLayer.push(arguments);\n' +
    '}\n' +
    '// set „denied" as default for both ad and analytics storage, as well as ad_user_data and ad_personalization,\n' +
    'gtag("consent", "default", {\n' +
    '  ad_user_data: "denied",\n' +
    '  ad_personalization: "denied",\n' +
    '  ad_storage: "denied",\n' +
    '  analytics_storage: "denied",\n' +
    '  wait_for_update: 2000 // milliseconds to wait for update\n' +
    '});' +
    'gtag("set", "ads_data_redaction", true);';
  firstScriptTag.parentNode.insertBefore(usercentricsScriptTag, firstScriptTag);

  for (const gaProperty of Object.keys(gtm.gaProperties)) {
    // prevent duplications if code is called twice
    if (document.querySelector('[src*="' + gaProperty + '"]')) {
      continue;
    }

    /* tslint:disable */
    (function (w, d, s: 'script', l, i) {
      w[l] = w[l] || [];
      w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
      const f: any = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = (l != 'dataLayer' ? '&l=' + l : '');
      j.async = true;
      j.src = gtm.gaSource[i] ?? 'https://tracking.faulhaber.com/gtm.js?id=' + i + dl + gtm.gaProperties[i] ?? '';
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', gaProperty);
    /* tslint:enable */
  }
}
